$('body').on('mousemove', function(e) {
	let target = $(e.target);
	if ((target.hasClass('js-targeted-part') || target.parents('.js-targeted-part').length)) {
		$('.js-section-product').addClass('overflow-section');
	} else {
		$('.js-section-product').removeClass('overflow-section');
	}
});
